<template>
  <div class="analytic-payment-page scrollable">
    <div class="card-base card-shadow p-30">
      <el-tabs v-model="activeTab">
        <el-tab-pane v-for="tab in tabs" :label="tab" :name="tab.toLowerCase()">
          <component :is="`Payment${tab}Tab`">
            <slot></slot>
          </component>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
  import PaymentChartsTab from './PaymentChartsTab'
  import PaymentInterestTab from './PaymentInterestTab'

  export default {
    name: 'PaymentPage',
    components: {
      PaymentChartsTab,
      PaymentInterestTab
    },
    data() {
      return {
        activeTab: 'charts',
        tabs: ['Charts','Interest']
      }
    }
  }
</script>
